import type { TDesignSystemRoot } from "@/shared/types";
import { withDesignSystemDefaults } from "./design-system-defaults";
import { applyFluidTypography } from "./fluid-typography";
import {
  applyBooleanCssTransforms,
  resolveDesignSystemVariables,
} from "./resolve-design-system-variables";

const updateDesignSystemRoot = (design: TDesignSystemRoot) => {
  // Fill in display/heading defaults for stories that predate those keys —
  // see design-system-defaults.ts for the rationale.
  const filled = withDesignSystemDefaults(
    design as unknown as Record<string, unknown>,
  );
  const root = document.documentElement;
  const setProperty = (cssVar: string, value: string) =>
    root.style.setProperty(cssVar, value);

  for (const [cssVar, cssValue] of resolveDesignSystemVariables(filled)) {
    setProperty(cssVar, cssValue);
  }

  // Boolean transforms are handled separately because they flip CSS
  // function values rather than raw strings. Single source of truth in
  // `resolve-design-system-variables.ts`.
  applyBooleanCssTransforms(filled, setProperty);

  // Re-wrap the font-size vars we just set as plain px into fluid clamp()s so
  // mobile keeps fluid typography after any design-system change. Idempotent
  // (clamp max is recovered on re-run) and a no-op in PDF export.
  applyFluidTypography();
};

export default updateDesignSystemRoot;
